import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSliderModule } from '@angular/material/slider';
import { RadioModule } from './radio';
import { FormFieldModule } from './form-field';
import { InputModule } from './input';
import { AutocompleteModule } from './autocomplete';
import { MenuModule } from './menu';
import { SlideToggleModule } from './slide-toggle';
import { TabsModule } from './tabs';
import { ButtonModule } from './button';
import { SelectModule } from './select';

const modules = [
  AutocompleteModule,
  MatButtonToggleModule,
  ButtonModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatExpansionModule,
  FormFieldModule,
  InputModule,
  MatListModule,
  MenuModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  RadioModule,
  MatRippleModule,
  SelectModule,
  MatSliderModule,
  SlideToggleModule,
  MatSnackBarModule,
  MatTableModule,
  TabsModule,
  MatToolbarModule,
  MatTooltipModule,
  DragDropModule,
];

@NgModule({
  imports: [...modules],
  exports: [...modules],
})
export class MaterialModule {}
